import {
  GET_GOOGLE_CONTACT_REQUEST,
  GET_GOOGLE_CONTACT_SUCCESS,
  GET_GOOGLE_CONTACT_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const googleContactReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_GOOGLE_CONTACT_REQUEST:
      return {
        ...state,
        data: action.payload,
        loading: true,
        error: null,
      };
    case GET_GOOGLE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_GOOGLE_CONTACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
